// Error types MUST end with the word ERROR

export const NETWORK_ERROR = 'NETWORK_ERROR';
export const LINK_ERROR = 'LINK_ERROR';
export const COMPONENT_ERROR = 'COMPONENT_ERROR';
export const OPERATIONAL_ERROR = 'OPERATIONAL_ERROR';
export const UNHANDLED_ERROR = 'UNHANDLED_ERROR';
